import axios from "axios";
import Config from "../utilities/Config";
const BASE_URL = `${Config.baseUrl}api/admin`;
const GENERAL_API_URL = `${Config.baseUrl}api`;

class SubscriptionRequests {
  getHeaders() {
    const token = localStorage.getItem("txtconnect_ng_admin_token");
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }

  async getAllPlans() {
    try {
      const response = await axios.get(`${GENERAL_API_URL}/all_plans`, {
        headers: this.getHeaders(),
      });
      return {
        status: true,
        data: response.data,
        message: "Subscription plans fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason || "Error fetching subscription plans",
      };
    }
  }

  async createPlan(planData) {
    try {
      const response = await axios.post(`${BASE_URL}/create_plans`, planData, {
        headers: this.getHeaders(),
      });
      return {
        status: true,
        data: response.data,
        message: "Subscription plan created successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason || "Error creating subscription plan",
      };
    }
  }

  async updatePlan(planId, planData) {
    try {
      const response = await axios.put(
        `${BASE_URL}/update_plans/${planId}`,
        planData,
        {
          headers: this.getHeaders(),
        }
      );
      return {
        status: true,
        data: response.data,
        message: "Subscription plan updated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason || "Error updating subscription plan",
      };
    }
  }

  async deletePlan(planId) {
    try {
      const response = await axios.delete(
        `${BASE_URL}/delete_plans/${planId}`,
        {
          headers: this.getHeaders(),
        }
      );
      return {
        status: true,
        data: response.data,
        message: "Subscription plan deleted successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.reason || "Error deleting subscription plan",
      };
    }
  }

  async getUserSubscription() {
    try {
      const response = await axios.get(`${BASE_URL}/all_subscriptions`, {
        headers: this.getHeaders(),
      });
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data.reason || "Subscriptions fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.data?.reason ||
          "Error fetching user subscription",
      };
    }
  }

  async getUserSubscriptionHistory(userId) {
    try {
      const response = await axios.get(
        `${BASE_URL}/subscription_history/${userId}`,
        {
          headers: this.getHeaders(),
        }
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data.reason ||
          "Subscription history fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error?.response?.data?.data?.reason ||
          "Error fetching user subscription history",
      };
    }
  }

  // Export subscriptions/payments to file, filtered by whatever is passed in.
  // TODO: query param names (status, plan_name, network, package_name, phone_number, email)
  // and the "status" value vocabulary are per spec but unverified against a live backend.
  async exportSubscriptions(filters = {}) {
    const {
      status = "",
      plan_name = "",
      network = "",
      package_name = "",
      phone_number = "",
      email = "",
    } = filters;
    try {
      const params = new URLSearchParams({
        ...(status && { status }),
        ...(plan_name && { plan_name }),
        ...(network && { network }),
        ...(package_name && { package_name }),
        ...(phone_number && { phone_number }),
        ...(email && { email }),
      });

      const response = await axios.get(
        `${BASE_URL}/payments/export?${params.toString()}`,
        {
          headers: this.getHeaders(),
          responseType: "blob",
        }
      );

      // The backend returns plain CSV for this endpoint (not a real .xlsx
      // binary) — keep the MIME type from the response instead of dropping
      // it, and default to a .csv name so the extension always matches the
      // actual bytes even if Content-Disposition isn't readable (browsers
      // hide that header cross-origin unless the backend explicitly exposes
      // it via Access-Control-Expose-Headers; Content-Type doesn't have
      // that restriction, so it's the reliable one to fall back on).
      const responseContentType =
        response.data?.type || response.headers["content-type"] || "text/csv";
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: responseContentType })
      );
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "subscriptions_export.csv";
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch && fileNameMatch.length === 2) {
          fileName = fileNameMatch[1];
        }
      } else if (responseContentType.includes("spreadsheet") || responseContentType.includes("excel")) {
        fileName = "subscriptions_export.xlsx";
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return {
        status: true,
        message: "Export started successfully",
      };
    } catch (error) {
      return {
        status: false,
        message:
          error?.response?.data?.data?.reason ||
          error?.response?.data?.message ||
          "Failed to export subscriptions",
      };
    }
  }
}

const subscriptionRequests = new SubscriptionRequests();
export default subscriptionRequests;
